export const EXPORT_FORMAT_XLSX = "xlsx";
export const EXPORT_FORMAT_CSV = "csv";

export const EXPORT_FORMAT_OPTIONS = [
  { value: EXPORT_FORMAT_XLSX, label: "Excel (.xlsx)" },
  { value: EXPORT_FORMAT_CSV, label: "CSV (.csv)" },
];

export function getExportFileExtension(format) {
  return format === EXPORT_FORMAT_CSV ? "csv" : "xlsx";
}

export function getExportDownloadLabel(format) {
  return format === EXPORT_FORMAT_CSV ? "CSV" : "Excel";
}
